/**
 * Kingdom Factor - Reusable Footer
 * Used across all public-facing pages
 */

import { Link } from "@inertiajs/react"
import logoDark from "@/assets/logos/logo-dark.svg"

const footerLinks = [
  { href: "/collective", label: "Leader Stories", id: "collective", isExternal: true },
  { href: "/our-calling", label: "Our Calling", id: "our-calling" },
  { href: "/statement-of-faith", label: "Statement of Practice", id: "statement-of-faith" },
  { href: "/legal", label: "Legal", id: "legal" },
  { href: "/login", label: "Login", id: "login" },
]

export function Footer({ activePage }) {
  return (
    <footer className="bg-kf-black py-12 print:hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <Link href="/">
            <img src={logoDark} alt="Kingdom Factor" className="h-8" />
          </Link>
          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400">
            {footerLinks.map((link) =>
              link.isExternal ? (
                <a
                  key={link.id}
                  href={link.href}
                  className="hover:text-white transition-colors"
                >
                  {link.label}
                </a>
              ) : (
                <Link
                  key={link.id}
                  href={link.href}
                  data-tour={link.id === "login" ? "footer-login-link" : undefined}
                  className={`transition-colors ${
                    activePage === link.id ? "text-white" : "hover:text-white"
                  }`}
                >
                  {link.label}
                </Link>
              )
            )}
          </div>
          <p className="text-sm text-gray-600">
            &copy; {new Date().getFullYear()} Kingdom Factor USA
          </p>
        </div>
      </div>
    </footer>
  )
}
